/* TODO: translate */

import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-autocomplete',
    'hint',
    'Izmanto augšup vai lejup vērstās bultiņas, lai noklausītos, un taustiņu Enter, lai izvēlētos.'
);
Labels.set('ui-autocomplete', 'suggestions', 'Ieteikumi');
Labels.set('ui-autocomplete', 'suggestionsFound', 'Parādītie ieteikumi: ');
Labels.set('ui-autocomplete', 'noSuggestionsFound', 'Nav ieteikumu');
